import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { parseComboBoxValue } from '@/common/helpers/helpers'

import { getMenuItems } from './helpers'

const DeliveryMethodSelector = ({ onChange, value, deliveryMethods = [] }) => {
  const { t } = useTranslation()

  return (
    <ComboBox
      handleChange={e => onChange(parseComboBoxValue(e.target.value))}
      value={value || ''}
      label={t('Método de devolución')}
      fullWidth
      menuItems={getMenuItems(deliveryMethods)}
    />
  )
}

export default DeliveryMethodSelector
